import { t } from "@/plugins/vue-i18n";

import { ListStore } from "@/stores/lists";
import { useSupplierStore } from "@/stores/suppliers";

import { isApp } from "@/functions/enviroment";

import { ListItem, CatalogItem } from "@/types/supplier";
import { ChangeEvent } from "@/types/ionicEvents";
import { RECYCLE_CATEGORY_SIZE } from "@/assets/variables";

export const combineItems = (sortedListItemsCat: { [key: string]: ListItem[] }, noCategoryItems: ListItem[]): ListItem[] => {
    //sort categories alphabetical
    const orderedCatListItems = Object.keys(sortedListItemsCat).sort(
        function (a, b) {
            return a.localeCompare(b);
        }).reduce(
            (obj: { [key: string]: ListItem[] }, key: string) => {
                obj[key] = sortedListItemsCat[key];
                return obj;
            },
            {}
        );
    //add no cat items at end
    if (noCategoryItems.length) {
        orderedCatListItems[t('label.noCategory')] = []
        orderedCatListItems[t('label.noCategory')].push(...noCategoryItems)
    }
    //create array for list
    const sortedListItems: ListItem[] = []
    for (const key of Object.keys(orderedCatListItems)) {
        sortedListItems.push({
            id: key,
            recycleId: key,
            item: { id: 'isCategory', name: '' },
            supplierItemId: '',
            listId: '',
            size: RECYCLE_CATEGORY_SIZE,
            quantity: 0,
            targetStock: 0,
            piecePrice: 0
        })
        sortedListItems.push(...orderedCatListItems[key])
    }
    return sortedListItems
}

export const queryMatches = (item: CatalogItem, query?: string): boolean | undefined => {
    if (!query) return true
    return item.name?.toLowerCase().includes(query) ||
        item.itemNumber?.toLowerCase() === query ||
        item.itemGroup1?.toLowerCase().includes(query) ||
        item.itemGroup2?.toLowerCase().includes(query)
}

export const hasSearchKey = (state: ListStore): boolean => {
    if (!isApp()) return !!state.searchQuery

    return !!useSupplierStore().searchQuery
}
// TODO: Change event type to AccordionGroupCustomEvent
export const removeInputFocus = (event: ChangeEvent): void => {
    if (event.srcElement.tagName === 'ION-INPUT' || event.srcElement.tagName === 'ION-SELECT') return
    if (document.activeElement) (document.activeElement as HTMLElement).blur()
}

export const haveSameIds = (a: readonly { id: string }[], b: readonly { id: string }[]): boolean => {
    if (a.length !== b.length) return false

    const ids = new Set(a.map(i => i.id))

    for (const item of b) {
        if (!ids.has(item.id)) return false
    }

    return true
}

export function haveSameContent(
    a: readonly { id: string; image?: { url?: string } }[],
    b: readonly { id: string; image?: { url?: string } }[]
): boolean {
    if (a.length !== b.length) return false

    const map = new Map(a.map(i => [i.id, i.image?.url]))

    for (let i = 0; i < b.length; i++) {
        const item = b[i]

        if (map.get(item.id) !== item.image?.url) {
            return false
        }
    }

    return true
}